/** @file publishQueue: copies the queue's view, confirmed revision and pending count into `puppet`. */
import type { ServerContext } from './serverContext';

/** No-op while no puppet is open. */
export function publishQueue(ctx: ServerContext): void {
  const q = ctx.queue;
  if (q === null) return;
  ctx.set((s) => ({ puppet: { ...s.puppet, doc: q.view(), revision: q.confirmed().revision, pending: q.pending() } }));
}
